module.exports = __webpack_public_path__ + "static/media/icon-social.c12ee892.svg";